
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import api, { oceanDemoQuery, getChallanPartnerDetails } from '../Base/Config';
import Message from '../Components/Message/Message';
import styles from './check-challan.module.css';
import { getPreSignedUrlGetObj } from '../Utils/preSignedUrl';

export default function CheckChallan() {
    const navigate = useNavigate();
    const brandName = useParams().brandName;
    const apiDomain = process.env.REACT_APP_PUBLIC_CONFIG_URL;
    const faqs = [
        {
            q: 'Which challans can I pay? ',
            a: 'We support online challans, offline challans, and physical court challans across almost all states in India.'
        },
        {
            q: 'How long does it take to settle a challan?',
            a: [
                'Online & Virtual Court Challans: 3-4 working days',
                'Physical Court Challans: 10-20 working days (depending on state)'
            ]
        },
        {
            q: 'Do I get proof of payment?',
            a: 'Yes. We share an official challan receipt for every settlement.'
        },
        {
            q: 'What happens if the challan gets settled for a lower amount?',
            a: 'We immediately refund the excess amount after deducting a small service charge.'
        },
        {
            q: 'Can I integrate challan payments into my app/website?',
            a: 'Absolutely! We provide APIs and white-label solutions, along with backend operations, so you can go live instantly.'
        }
    ];
    const [openIdx, setOpenIdx] = React.useState(null);
    const [vehicleNumber, setVehicleNumber] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [otp, setOtp] = React.useState('');
    const [otpSent, setOtpSent] = React.useState(false);
    const [resendOtp, setResendOtp] = React.useState(false);
    const [phoneNumberModal, setPhoneNumberModal] = React.useState(false);
    const [verificationToken, setVerificationToken] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState('')
    const [messageClass, setMessageClass] = React.useState('')
    const [accessToken, setAccessToken] = React.useState()
    const [fullName, setFullName] = React.useState()
    const [email, setEmail] = React.useState()
    const [phone, setPhone] = React.useState()
    const [companyName, setCompanyName] = React.useState()
    const [formMessage, setFormMessage] = React.useState()
    const [partnerDetails, setPartnerDetails] = React.useState()
    const [partnerDetailsCheck, setPartnerDetailsCheck] = React.useState(false)
    
    React.useEffect(()=>{
        if(sessionStorage.getItem('accessToken')){
            setAccessToken(sessionStorage.getItem('accessToken'))
        }
    }, [])

    const responsiveImages = {
        // the naming can be any, depends on you.
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1350 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1350, min: 950 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 950, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
        },
    }

    const getClientIdFromUrl = () => {
        sessionStorage.setItem('eChallanToken', JSON.stringify({token: brandName}))
        return brandName || '';
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!vehicleNumber) {
            setMessageClass('error')
            setMessage('Please enter vehicle number')
            setTimeout(() => setMessage(''), 5000)
            return;
        }

        if(accessToken){
            fetchChallanFunction();
        } else {
            setPhoneNumberModal(true);
        }
    };

    const submitPhoneFunction = (e) => {
        e.preventDefault();
        sendOtpFunction();
    };

    const sendOtpFunction = () => {
        setLoading(true);
        setResendOtp(false);
        axios.post(`${apiDomain}/echallan-send-otp`, { 
            mobileNumber: phoneNumber,
            authToken: getClientIdFromUrl()
        })
        .then((res) => {
            setLoading(false);
            if(res.data.code===200) {
                setOtpSent(true)
                setVerificationToken(res.data.token)
                setTimeout(() => setResendOtp(true), 30000)
            } else {
                setMessageClass('error')
                setMessage(res.data.message)
                setTimeout(() => setMessage(''), 5000)
            }
        })
        .catch((error) => {
            console.error(error);
            setLoading(false);
            setMessageClass('error');
            setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
            setTimeout(() => setMessage(''), 5000)
        })
    };

    const submitOtpFunction = (e) => {
        e.preventDefault();
        setLoading(true);
        axios.post(`${apiDomain}/echallan-verify-otp`, { 
            otp: otp,
            verificationToken: verificationToken
        })
        .then((res) => {
            if(res.data.code===200) {
                setAccessToken(res.data.accessToken)
                fetchChallanFunction(res.data.accessToken);
                sessionStorage.setItem('accessToken', res.data.accessToken);
            } else {
                setLoading(false);
                setMessageClass('error')
                setMessage(res.data.message)
                setTimeout(() => setMessage(''), 5000)
            }
        })
        .catch((error) => {
            console.error(error);
            setLoading(false);
            setMessageClass('error');
            setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
            setTimeout(() => setMessage(''), 5000)
        })
    };

    const fetchChallanFunction = (token) => {
        setLoading(true);
        axios.post(`${apiDomain}/vehicle-echallan-detail-V2`, {
            vehicleNumber: vehicleNumber,
            accessToken: token ? token : accessToken
        })
        .then((res) => {
            setLoading(false);
            if(res.data.code===200) {
                sessionStorage.setItem('challanDetails', JSON.stringify(res.data));
                navigate('/challan-details');
            } else {
                setPhoneNumberModal(true);
                setOtpSent(false);
                setOtp('');
                setMessageClass('error')
                setMessage(res.data.message)
                setTimeout(() => setMessage(''), 5000)
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
            setMessageClass('error');
            setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
            setPhoneNumberModal(false);
            setOtpSent(false);
            setOtp('');
            setTimeout(() => setMessage(''), 5000)
        })
    };

    const sendRequest = (e) => {
        e.preventDefault();
        setLoading(true)
        api.post(oceanDemoQuery, {
            name: fullName,
            email: email,
            phone: phone,
            companyName: companyName,
            message: formMessage,
            productName: 'Challan Detailed Page'
        })
        .then((res) => {
            if (res.data.code === 100) {
                setFullName('')
                setEmail('')
                setPhone('')
                setCompanyName('')
                setFormMessage('')
                setMessageClass('success')
            } else {
                setMessageClass('error')
            }
            setLoading(false)
            setMessage(res.data.message)
            setTimeout(() => setMessage(''), 5000)
        })
        .catch((error) => {
            console.error(error)
            setLoading(false)
            setMessageClass('error')
            setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
            setTimeout(() => setMessage(''), 5000)
        })
    }

    const fetchPartnerDetails = () => {
        setLoading(true)
        api.get(getChallanPartnerDetails + brandName)
        .then(async (res) => {
            if (res.data.code === 100) {
                setPartnerDetails(res.data.result)
                await setTargetAndSrcImg(res.data.result.companyLogo)
            } else {
                setPartnerDetailsCheck(true)
                console.log(res.data)
            }
            setLoading(false)
        })
        .catch((error) => {
            console.error(error)
            setPartnerDetailsCheck(true)
            setLoading(false)
            setMessageClass('error')
            setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
            setTimeout(() => setMessage(''), 5000)
        })
    }

    useEffect(() => {
        fetchPartnerDetails();
    }, [])

    const srcImg = React.useRef(null)

    const setTargetAndSrcImg = async (srcImgKey) => {
        try {
            const srcImgUrl = await getPreSignedUrlGetObj(srcImgKey, "oceanService")
            srcImg.current = srcImgUrl
            setPartnerDetailsCheck(true)
        } catch (err) {
            throw new Error(err)
        }
    }
    
    const targetDivRef = React.useRef(null);

    const scrollToDiv = () => {
        targetDivRef.current.scrollIntoView({
            behavior: "smooth", // Smooth scrolling
            block: "start", // Scroll to the start of the target div
        });
    };

    return (<>
        {message && <Message message={message} messageClass={messageClass} closeMessage={() => setMessage('')} />}
        <div className={styles.checkChallanWrapper}>
            <header className={styles.header}>
                <div className="container">
                    <div className={styles.headerBox}>
                        {
                            partnerDetailsCheck
                            ?<img src={srcImg?.current?srcImg.current:'../images/challan-detailed/finii-logo.png'} alt="logo" className={styles.logo} />
                            :<span></span>
                        }
                    </div>
                </div>
            </header>
            <div className={styles.heroSection}>
                <div className="container">
                    <div className={styles.mainContent}>
                        <section className={styles.leftSection}>
                            <div className={styles.digitalIndiaCard}>
                                <img className={styles.digitalIndiaIcon} src="../../images/challanDashboard/india-initiative.png" alt="" />
                                <div className={styles.digitalIndiaTitle}>Digital India Initiative</div>
                                <div className={styles.digitalIndiaDesc}>Empowering millions of vehicle owners with instant access to traffic violation information</div>
                                <div className={styles.digitalIndiaStats}>
                                    <div>30+ <span>Crore Vehicle</span></div>
                                    <div>24/7 <span>Service</span></div>
                                </div>
                            </div>
                            <div className={styles["howItWorksCard"]}>
                                <div className={styles.howItWorksTitle}>
                                    <img src="../images/challan-detailed/how's-work.png" alt="" /> How It Works?
                                </div>
                                <div>The Challan System manages all your challan requests on your behalf. You simply make the payment, and our team ensures settlement within 3-4 days for all online and virtual court challans. For physical court challans, we provide settlement services within 20 days across all states except Maharashtra, Puducherry, Arunachal Pradesh, the North-Eastern states, Telangana, and Karnataka.</div>
                                <div className={styles["howItWorksFeatures"]}>
                                    <div className={styles["featureGreen"]}> <img src="../images/challan-detailed/instant-notification.png" alt="" /> Instant Notification</div>
                                    <div className={styles["featureBlue"]}> <img src="../images/challan-detailed/online-payment-facility.png" alt="" /> Online Payment Facility</div>
                                    <div className={styles["featurePurple"]}> <img src="../images/challan-detailed/digital-recording.png" alt="" /> Digital Record keeping</div>
                                </div>
                            </div>
                        </section>
                        <section className={styles["rightSection"]}>
                            <div className={styles["challanCard"]}>
                                <div className={styles["challanTitle"]}>Stay updated on your challans.</div>
                                <div className={styles["challanSubtitle"]}>Built for India's 30+ crore vehicles - growing with you every day.</div>
                                {
                                    phoneNumberModal
                                    ?<>
                                        {
                                            otpSent
                                            ?<form onSubmit={submitOtpFunction}>
                                                <label>OTP sent on {phoneNumber} <img onClick={() => setOtpSent(false)} src="../images/challan-detailed/edit.png" alt="edit" /> {resendOtp ? <span onClick={() => sendOtpFunction()} className={styles['resend-otp']}>Resend</span> : <span>Resend in 30s</span>}</label>
                                                <div className={styles["challanOtpInput"]}>
                                                    {[0,1,2,3,4,5].map(i => (
                                                        <input
                                                            key={i}
                                                            type="tel"
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            maxLength={1}
                                                            className={styles['otp-box']}
                                                            value={otp[i] || ''}
                                                            onChange={e => {
                                                                let val = e.target.value.replace(/[^0-9]/g, '');
                                                                let otpArr = otp.split('');
                                                                otpArr[i] = val;
                                                                setOtp(otpArr.join('').slice(0,6));
                                                                // Move focus forward
                                                                if(val && i<5) {
                                                                    const next = document.getElementById('otp-box-'+(i+1));
                                                                    if(next) next.focus();
                                                                }
                                                            }}
                                                            onKeyDown={e => {
                                                                if(e.key === 'Backspace') {
                                                                    if(!otp[i] && i > 0) {
                                                                        let otpArr = otp.split('');
                                                                        otpArr[i-1] = '';
                                                                        setOtp(otpArr.join('').slice(0,6));
                                                                        const prev = document.getElementById('otp-box-'+(i-1));
                                                                        if(prev) prev.focus();
                                                                        e.preventDefault();
                                                                    }
                                                                }
                                                            }}
                                                            id={`otp-box-${i}`}
                                                            autoFocus={i===0}
                                                        />
                                                    ))}
                                                </div>
                                                {
                                                    loading
                                                    ?<button className={styles["challanBtn"]} disabled><img  src='../images/challan-detailed/btnLoader.gif' alt=''/></button>
                                                    :<button className={styles["challanBtn"]}>Verify OTP</button>
                                                }
                                            </form>
                                            :<form onSubmit={submitPhoneFunction}>
                                                <label>Enter phone number</label>
                                                <div className={styles["challanInputRow"]}>
                                                    <input className={styles["phoneInput"]} placeholder="Enter phone number" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
                                                </div>
                                                {
                                                    loading
                                                    ?<button className={styles["challanBtn"]} disabled><img  src='../images/challan-detailed/btnLoader.gif' alt=''/></button>
                                                    :<button className={styles["challanBtn"]}>Send OTP</button>
                                                }
                                            </form>
                                        }
                                    </>
                                    :<form onSubmit={handleSubmit}>
                                        <label>Enter vehicle number</label>
                                        <div className={styles["challanInputRow"]}>
                                            <span className={styles["challanInputPrefix"]}>IND</span>
                                            <input className={styles["challanInput"]} placeholder="HR XX N 9090" value={vehicleNumber} onChange={e => setVehicleNumber(e.target.value.toLocaleUpperCase())} />
                                        </div>
                                        {
                                            loading
                                            ?<button className={styles["challanBtn"]} disabled><img  src='../images/challan-detailed/btnLoader.gif' alt=''/></button>
                                            :<button className={styles["challanBtn"]}>Search Challan Details</button>
                                        }
                                    </form>
                                }
                                <hr />
                                <div className={styles["challanGuarantee"]}>
                                    <img src="../images/challan-detailed/batch-icon.png" alt='' />
                                    <span>Settlement within <i>3 - 4 days</i>, or get a <i>100% refund</i> - guaranteed</span>
                                </div>
                                <div className={styles["challanFeaturesRow"]}>
                                    <span> <img src='../images/challan-detailed/right-sign.png' alt='' /> Official RTO Data</span>
                                    <span> <img src='../images/challan-detailed/right-sign.png' alt='' /> 100% Free & Secure</span>
                                    <span><img src='../images/challan-detailed/right-sign.png' alt='' /> Instant Results</span>
                                </div>
                            </div>
                            <div>
                                <span className={styles.trustedTitle}>TRUSTED BY:</span>
                                <div className={styles.trustedLogos}>
                                    <Carousel
                                        swipeable={true}
                                        draggable={true}
                                        showDots={false}
                                        arrows={false}
                                        responsive={responsiveImages}
                                        infinite={true}
                                        autoPlay={true}
                                        autoPlaySpeed={2000}
                                        containerClass="carousel-container"
                                    >
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/audi.png" alt="audi" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/bajaj-finserv.png" alt="finserv" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/digit.png" alt="digit" />
                                        </div>
                                        <div className={`${styles['carousel-item']} ${styles['big-icon']}`}>
                                            <img src="/images/challan-detailed/logo/hindustan-unilever.png" alt="unilever" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/nayara-energy.png" alt="energy" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/reliance-general-insurance.png" alt="insurance" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/shriram.png" alt="shriram" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/skoda.png" alt="skoda" />
                                        </div>
                                        <div className={`${styles['carousel-item']} ${styles['big-icon']}`}>
                                            <img src="/images/challan-detailed/logo/toyota.png" alt="toyota" />
                                        </div>
                                        <div className={styles['carousel-item']}>
                                            <img src="/images/challan-detailed/logo/volkswagen.png" alt="volkswagen" />
                                        </div>
                                    </Carousel>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            {/* FAQ Section */}
            <section className={styles.faqSection}>
                <div className={styles.faqHeader}>
                    <p className={styles.faqIcon}><span><img src='../images/challan-detailed/faq-icon.png' alt='' /> FAQs</span></p>
                    <h2 className={styles.faqTitle}>Frequently Asked Questions</h2>
                    <div className={styles.faqSubtitle}>Find quick answers to common questions about our challan fulfillment services</div>
                </div>
                <div className={styles.faqList}>
                    {faqs.map((faq, idx) => (
                        <div
                            key={idx}
                            className={openIdx === idx ? `${styles.faqItem} ${styles.active}` : styles.faqItem}
                        >
                            <button
                                className={styles.faqQuestion}
                                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                                aria-expanded={openIdx === idx}
                            >
                                {faq.q}
                                <span className={`fa fa-angle-down ${styles.faqArrow}`}></span>
                            </button>
                            {openIdx === idx && (
                                <div className={styles.faqAnswer}>
                                    {Array.isArray(faq.a) ? (
                                        <ul className={styles.faqAnswerList}>
                                            {faq.a.map((point, i) => (
                                                <li key={i}>{point}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        faq.a
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>
            {/* Become a Partner or Affiliate Section */}
            <section className={styles.partnerSection}>
                <div className={styles.partnerHeaderRow}>
                    <p className={styles.partnerDiscover}><span><img src='../images/challan-detailed/affiliate-partnes-icon.png' alt='' /> Discover our features</span></p>
                    <h2 className={styles.partnerTitle}>
                    Become a Partner or <span className={styles.partnerAffiliate}>Affiliate</span>
                    </h2>
                    <div className={styles.partnerSubtitle}>
                         Integrate the Pay Challan List into your app, website, or ecosystem.
                    </div>
                </div>
                <div className={styles.partnerContentRow}>
                    <div className={styles.partnerLeft}>
                    {/* <button className={styles.partnerMainBtn} onClick={() => scrollToDiv()}>Become a Partner →</button> */}
                    <div className={styles.partnerDesc}>
                        Join our trusted partner network and deliver seamless challan fulfillment services across India. Scale your business with our proven platform while earning competitive commissions.
                    </div>
                    </div>
                    <div className={styles.partnerRight}>
                    <div className={styles.partnerCardGreen}>
                        <span className={styles.partnerCardIcon}><img src='../images/challan-detailed/earn-more.png' alt='' /></span>
                        <div>
                        <div className={styles.partnerCardTitle}>Earn More</div>
                        <div className={styles.partnerCardDesc}>Get up to <b>50% commission</b> for every challan settled through your channel.</div>
                        </div>
                    </div>
                    <div className={styles.partnerCardBlue}>
                        <span className={styles.partnerCardIcon}><img src='../images/challan-detailed/operational-hassle.png' alt='' /></span>
                        <div>
                        <div className={styles.partnerCardTitle}>Zero Operational Hassle</div>
                        <div className={styles.partnerCardDesc}>We handle the entire back-end fulfillment across nearly every state - you just focus on growth.</div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>

            <section className={styles.integrationSection}>
                <div className={styles.integrationHeader}>
                    <span className={styles.integrationTag}><i className="fa fa-code"></i> Developer ready</span>
                    <h2 className={styles.integrationTitle}>Ready to integrate?</h2>
                    <div className={styles.integrationSubtitle}>
                    Start processing challans in minutes with our comprehensive APIs and documentation. Scale from prototype to production seamlessly.
                    </div>
                    <button className={styles.integrationBtn} onClick={() => scrollToDiv()}>Schedule a demo call</button>
                </div>
            </section>

            <section className={styles.featuresSection}>
                <div className={styles.featuresHeader}>
                    <span className={styles.featuresTag}>🔮 Powerful features</span>
                    <h2 className={styles.featuresTitle}>Build for modern business</h2>
                    <div className={styles.featuresSubtitle}>
                        Everything you need to manage challans efficiently, from instant payments to comprehensive APIs<br />
                        Instant Processing
                    </div>
                </div>
                <div className={styles.featuresGrid1}>
                    <div className={styles["featureCardBlue"]}>
                        <div>
                            <span className={styles.featureCardTag}><img src="../images/challan-detailed/instant-icon.png" alt=""/> Instant Processing</span>
                            <div className={styles["featureCardTitle"]}>Build for modern business</div>
                            <div className={styles["featureCardDesc"]}>Our dashboard lets you view and pay all your challans instantly. Want this integrated into your system? We’ve got APIs for that.</div>
                        </div>
                        <div>
                            <img src="../images/challan-detailed/modern-business.png" alt="Dashboard" className={styles.featureCardIcon} />
                        </div>
                    </div>
                    <div className={styles["featureCardPurple"]}>
                        <div>
                            <span className={styles["featureCardTag"]}><img src="../images/challan-detailed/d-api.png" alt=""/></span>
                            <div className={styles["featureCardTitle"]}>Developer APIs</div>
                            <div className={styles["featureCardDesc"]}>Integrate our challan APIs directly into your platform for seamless automation.</div>
                        </div>
                        <div>
                            <img src="../images/challan-detailed/developer-api.png" alt="API" className={styles.featureCardIcon} />
                        </div>
                    </div>
                </div>
                <div className={styles.featuresGrid2}>
                    <div className={styles["featureCardGreen"]}>
                        <div>
                            <span className={styles["featureCardTag"]}><img src="../images/challan-detailed/cs-icon.png" alt="Dashboard"/></span>
                            <div className={styles["featureCardTitle"]}>Complete Solution</div>
                            <div className={styles["featureCardDesc"]}>From payment processing to compliance management, we handle it all.</div>
                        </div>
                        <div>
                            <img src="/images/challan-detailed/complete-solution.png" alt="Compliance" className={styles.featureCardIcon} />
                        </div>
                    </div>
                    <div className={styles["featureCardYellow"]}>
                        <div>
                            <span className={styles["featureCardTag"]}> <img src='../images/challan-detailed/white-label.png' alt='' /> White Label Ready</span>
                            <div className={styles["featureCardTitle"]}>Your Brand, Our Technology</div>
                            <div className={styles["featureCardDesc"]}>Complete white-label solution with your branding. We manage the backend, payments, and operations while you focus on your customers.</div>
                        </div>
                        <div>
                            <img src="/images/challan-detailed/our-technology.png" alt="White Label" className={styles.featureCardIcon} />
                        </div>
                    </div>
                </div>
            </section> 

            {partnerDetails?.hideContactform!==true && <section className={styles.getStartedSection} ref={targetDivRef}>
                <div className={styles.getStartedHeader}>
                    <span className={styles.getStartedTag}> <img src='../images/challan-detailed/get-in-touch.png' alt='' /> Get In Touch</span>
                    <h2 className={styles.getStartedTitle}>Get Started Today</h2>
                    <div className={styles.getStartedSubtitle}>Whether you’re an individual, a business, or a platform, We're here to simplify challan fulfillments.</div>
                </div>
                <form className={styles.getStartedForm} onSubmit={sendRequest}>
                    <div className={styles.getStartedFormRow}>
                        <div className={styles.getStartedFormGroup}>
                            <label>Name*</label>
                            <input type="text" placeholder="Demouser" value={fullName} onChange={e => setFullName(e.target.value)} required />
                        </div>
                        <div className={styles.getStartedFormGroup}>
                            <label>Email*</label>
                            <input type="email" placeholder="demouser@gmail.com" value={email} onChange={e => setEmail(e.target.value)} required />
                        </div>
                    </div>
                    <div className={styles.getStartedFormRow}>
                        <div className={styles.getStartedFormGroup}>
                            <label>Company Name</label>
                            <input type="text" placeholder="Tata Motors" value={companyName} onChange={e => setCompanyName(e.target.value)} required />
                        </div>
                        <div className={styles.getStartedFormGroup}>
                            <label>Phone Number*</label>
                            <input type="text" placeholder="823828282828" value={phone} onChange={e => setPhone(e.target.value)} required />
                        </div>
                    </div>
                    <div className={styles.getStartedFormGroup}>
                        <label>Message</label>
                        <textarea placeholder="Type message here...." rows={3} value={formMessage} onChange={e => setFormMessage(e.target.value)} required></textarea>
                    </div>
                    <button type="submit" className={styles.getStartedBtn} disabled={loading}>Send query</button>
                </form>
            </section>}
            <footer className={styles.getStartedFooter}> © {new Date().getFullYear()} {partnerDetails?.brandName?partnerDetails?.brandName:'Invincible Ocean Private Limited'} | All rights reserved </footer>
        </div>
    </>);
}